import React from 'react'

const SettingShippingCarrierContext = React.createContext({})

export default SettingShippingCarrierContext
